import { Badge, Box, Button, Divider, Heading, Text, useDisclosure, useToast, VStack } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function ArticleCard({
    id,
    articleId,
    title,
    category,
    createdAt,
    connected_time,
    email,
    phone,
    status,
    onStatusChange,
    onConnectedAction,
    plan,
    planData
}) {

    const [showModal, setShowModal] = useState(false);
    const { isOpen: isModal2Open, onOpen: openModal2, onClose: closeModal2 } = useDisclosure();
    const [planMain, setPlanMain] = useState([])
    const [planobject, setPlanObject] = useState({})
    const toast = useToast()
    const navigate = useNavigate();
    const login = JSON.parse(localStorage.getItem("login")) || "";
    // 🟢 Paid user → full access
    const isPaid = plan && plan.sale_price > 0;

    // 🟡 Free user → blur everything & show modal
    const isFree = !isPaid;


    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false)
            }
            document.body.appendChild(script);
        })
    };

    const handlePayment = async (planmain) => {
        let orderIdMain = "11" + Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
        let orderId = orderIdMain;

        try {
            let res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
            if (!res) {
                alert("Razorpay SDK failed to load");
                return;
            }

            let paymentDetails = {
                user_id: login.permanent_ID,
                user_phone: login.name,
                transaction_id: orderId,
                amount: parseInt(planmain.sale_price) * 100,
                validity: planmain.validity,
                currency: "INR",
                payment_capture: 1,
                payment_mode: "online",
            };

            let options = {
                key: "rzp_test_zEWr4dOpfx4w2F",
                amount: paymentDetails.amount,
                currency: "INR",
                name: "Film Location",
                description: "Store Registration",

                // ⭐ RAZORPAY SUCCESS HANDLER
                handler: async function (response) {
                    paymentDetails.razorpay_payment_id = response.razorpay_payment_id;
                    paymentDetails.status = "Paid";

                    // Save payment
                    await axios.post(
                        `https://filmlocation.100billion.in/pay-storefees`,
                        paymentDetails
                    );

                    // ⭐ UPDATE PLAN
                    await axios.put(
                        `https://filmlocation.100billion.in/store/plan-update/${login.permanent_ID}`,
                        {
                            planObject: planmain
                        }
                    );

                    toast({
                        title: "Plan Upgrade Successful",
                        status: "success",
                        duration: 3000,
                        position: "top"
                    });
                    setShowModal(false)
                    await planData();
                },
            };

            let paymentObject = new window.Razorpay(options);
            paymentObject.open();

        } catch (error) {
            console.log(error);
        }
    };


    // When FREE: clicking anywhere opens modal
    const handleCardClick = () => {
        if (isFree) setShowModal(true);
    };


    const getPlan = async () => {
        try {
            const response = await fetch(
                `https://filmlocation.100billion.in/vendor-storepricing/all/pricingall`
            );
            const res = await response.json();

            // ⭐ Filter out plans with sale_price = 0
            const filteredPlans = res.filter((plan) => plan.sale_price > 0);

            setPlanMain(filteredPlans);

        } catch (error) {
            console.log(error);
        }
    };





    useEffect(() => {
        getPlan();
    }, [])

    return (
        <>
            <div
                className="article-card"
                onClick={handleCardClick}
                style={{
                    position: "relative",
                    cursor: isFree ? "pointer" : "default"
                }}
            >

                {/* OVERLAY BLUR for FREE users */}
                {isFree && (
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            backdropFilter: "blur(4px)",
                            background: "rgba(255,255,255,0.6)",
                            zIndex: 2
                        }}
                    ></div>
                )}

                {/* 🔴 TOP STRIP */}
                <div
                    className="top-strip"
                    style={{ position: "relative", zIndex: 1 }}
                >
                    <span className="article-id">User Id: {articleId}</span>

                    <span>
                        {new Date(createdAt).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                        })}
                    </span>
                </div>

                {/* BODY */}
                <div className="body" style={{ position: "relative", zIndex: 1 }}>

                    {/* LEFT */}
                    <div className="left-section">
                        <p className="category-leadsvendor">{category}</p>

                        {/* ⭐ TITLE ALWAYS VISIBLE */}
                        <h2 className="title-leadsvendor" style={{ opacity: 1 }}>
                            {title}
                        </h2>

                        {/* Status Dropdown */}
                        <div className="row">
                            <select
                                className="select-box"
                                value={status}
                                disabled={isFree}
                                onChange={(e) => {
                                    if (!isFree) {
                                        onStatusChange(id, e.target.value);
                                    }
                                }}
                            >
                                <option value="">Select</option>
                                <option value="Pending">Pending</option>
                                <option value="Cancelled">Cancelled</option>
                                <option value="Converted">Converted</option>
                                <option value="Not Interested">Not Interested</option>
                                <option value="In Progress">In Progress</option>
                            </select>
                        </div>
                    </div>

                    {/* RIGHT ICONS */}
                    <div className="icon-section">

                        {/* 📞 CALL */}
                        <button
                            className="icon-btn"
                            disabled={isFree}
                            onClick={(e) => {
                                e.stopPropagation(); // prevent card click
                                if (isFree) return;
                                onConnectedAction(id, "call");
                                window.location.href = `tel:${phone}`;
                            }}
                        >
                            <i className="fa-solid fa-phone"></i>
                        </button>

                        {/* ✉️ EMAIL */}
                        <button
                            className="icon-btn"
                            disabled={isFree}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (isFree) return;
                                onConnectedAction(id, "email");
                                window.location.href = `mailto:${email}`;
                            }}
                        >
                            <i className="fa-solid fa-envelope"></i>
                        </button>

                    </div>
                </div>

                {/* ⭐ CONNECTED TIME (BOTTOM OF CARD) */}
                {connected_time && (
                    <div
                        style={{
                            padding: "8px 15px",
                            borderTop: "1px solid #eee",
                            fontSize: "13px",
                            color: "green",
                            background: "#f9fff9",
                            position: "relative",
                            zIndex: 1
                        }}
                    >
                        <b>Connected:</b>{" "}
                        {new Date(connected_time).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                        })}
                    </div>
                )}

            </div>

            {/* ===========================
                UPGRADE MODAL
            ============================ */}
            {showModal && (
                <div className="upgrade-modal">
                    <div className="modal-content">
                        <button
                            onClick={() => setShowModal(false)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                background: "transparent",
                                border: "none",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color:"black",
                                cursor: "pointer",
                            }}
                        >
                            ✕
                        </button>
                        <h2>Upgrade Required</h2>
                        <p>
                            You are currently on a free plan.
                            <br />
                            Please upgrade to unlock full access.
                        </p>

                        {planMain.map((plan, index) => (
                            <Box
                                key={index}
                                bg="white"
                                shadow="xl"
                                borderRadius="lg"
                                p={6}
                                w="280px"
                                textAlign="center"
                                border={planobject.plan_name === plan.plan_name ? "2px solid" : "1px solid"}
                                borderColor={planobject.plan_name === plan.plan_name ? "red.500" : "gray.200"}
                            >
                                <Badge
                                    colorScheme="red"
                                    variant="solid"
                                    borderRadius="full"
                                    px={3}
                                    py={1}
                                    mb={4}
                                    fontSize="sm"
                                    alignSelf="center"
                                >
                                    {plan.plan_name}
                                </Badge>
                                <Heading color="red.600" fontSize="4xl">
                                    ₹{plan.sale_price}
                                    <Text as="span" textDecoration={"line-through"} fontSize="lg" ml={"5px"} color="gray.600">
                                        ₹{plan.regular_price}
                                    </Text>
                                </Heading>
                                <Text as="span" fontSize="md" ml={"5px"} color="gray.600">
                                    {plan.validity}days
                                </Text>
                                <Divider my={6} borderColor="gray.300" />
                                <VStack spacing={3} mb={6}>
                                    <Text as="span" fontSize="lg" color="gray.600">
                                        {plan.description}
                                    </Text>
                                </VStack>
                                <Button
                                    bg={planobject.plan_name === plan.plan_name ? "red.600" : "red"}
                                    color={"white"}
                                    size="lg" w="full"
                                    onClick={() => {
                                        setPlanObject(plan);     // Select plan
                                        closeModal2();           // Close modal
                                        setTimeout(() => {
                                            handlePayment(plan);     // 🔥 Trigger payment automatically
                                        }, 100);                 // Small delay to ensure modal closes
                                    }}
                                    _hover={{ bg: planobject.plan_name === plan.plan_name ? "red.600" : "red" }}
                                >
                                    {planobject.plan_name === plan.plan_name ? "SELECTED" : "SELECT"}
                                </Button>
                            </Box>
                        ))}

                    </div>
                </div>
            )}
        </>
    );
}

export default ArticleCard;
